export default __webpack_public_path__ + "static/media/github.5d9e3d14.svg";